import { EDITOR_FLOOR_CHARACTER_SEED } from '@messenger/lotus'
import type {
  EditorCharacterStyleLayer,
  EditorResolvedStyle,
} from '@messenger/lotus'

export const effectiveCharacterStyle = (
  seed: EditorCharacterStyleLayer | EditorResolvedStyle | null | undefined,
  draft: EditorCharacterStyleLayer,
): EditorResolvedStyle => ({
  ...EDITOR_FLOOR_CHARACTER_SEED,
  ...authored(seed),
  ...authored(draft),
})

export const displayedLetterSpacingPt = (style: EditorResolvedStyle): number =>
  style.letterSpacing ?? 0

export const displayedTextCase = (
  style: EditorResolvedStyle,
): NonNullable<EditorResolvedStyle['textCase']> => style.textCase ?? 'none'

const authored = (
  layer: EditorCharacterStyleLayer | EditorResolvedStyle | null | undefined,
): Partial<EditorResolvedStyle> =>
  layer
    ? (Object.fromEntries(
        Object.entries(layer).filter(([, value]) => value !== undefined),
      ) as Partial<EditorResolvedStyle>)
    : {}
